import BaseButton from 'App/Services/DialogService/Components/Buttons/BaseButton';
import Component from 'vue-class-component';

@Component({
    name: 'cancel-button'
})
export default class CancelButton extends BaseButton {

}
